import type { ReactNode } from "react";

import { AssetsService } from "app/services/AssetsService";

import {
    StyledEmptyList,
    StyledEmptyListTitle,
    StyledEmptyListDescription,
    StyledEmptyListSubtitle,
} from "./styles";

type ExportPreviewEmptyStateProps = {
    title: ReactNode;
    description: ReactNode;
    subtitle: ReactNode;
    "data-automation"?: string;
};

export const ExportPreviewEmptyState = ({
    title,
    description,
    subtitle,
    "data-automation": dataAutomation,
}: ExportPreviewEmptyStateProps) => {
    return (
        <StyledEmptyList data-automation={dataAutomation}>
            <img
                src={AssetsService.assetUrl("/images/sales-intelligence/success.jpg")}
                alt="Success"
            />
            <StyledEmptyListTitle>{title}</StyledEmptyListTitle>
            <StyledEmptyListDescription>{description}</StyledEmptyListDescription>
            <StyledEmptyListSubtitle>{subtitle}</StyledEmptyListSubtitle>
        </StyledEmptyList>
    );
};
